import KnowledgeBase from './KnowledgeBase'

export default KnowledgeBase
